import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable camelcase */
import React from 'react';
import { dateFormat } from 'enums';
import { convertToAdditionalCurrency } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
var fundsFromName = {
  payment: 'Плащане',
  payment_report: 'Отчет плащания',
  commission_report: 'Отчет комисионни към кредитор',
  employee_to_partner_report: 'Отчетени такси ДП към касата на партньор',
  received_from_employee: 'Получени такси ДП от служител'
};
export var partnerFundsColumns = function partnerFundsColumns() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      showEmployee = _ref.showEmployee;

  return [{
    name: 'ИД',
    value: 'id',
    width: '80px'
  }, {
    name: 'Дата',
    value: 'date',
    dateTimeFormat: dateFormat,
    width: '120px'
  }].concat(_toConsumableArray(showEmployee ? [{
    name: 'Служител',
    render: function render(_ref2) {
      var _created_by$name;

      var created_by = _ref2.created_by;
      return ___EmotionJSX("span", null, (_created_by$name = created_by === null || created_by === void 0 ? void 0 : created_by.name) !== null && _created_by$name !== void 0 ? _created_by$name : '-');
    },
    width: '180px'
  }] : []), [{
    name: 'Основание',
    render: function render(_ref3) {
      var from = _ref3.from,
          credit = _ref3.credit;
      return ___EmotionJSX("span", null, "".concat(fundsFromName[from] || from, " ").concat(credit ? "#".concat(credit.number) : ''));
    }
  }, {
    name: 'Сума',
    render: function render(_ref4) {
      var amount = _ref4.amount,
          currency = _ref4.currency;
      return ___EmotionJSX("div", null, ___EmotionJSX("p", null, amount, " ", currency), ___EmotionJSX("p", null, convertToAdditionalCurrency({
        value: amount,
        fromCurrency: currency
      })));
    },
    width: '120px'
  }]);
};